exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_layout__3F9l_{display:flex;flex-direction:column;width:100%}.style_headerContentAlignment__2DmFe{padding-left:1rem;padding-right:1rem}.style_title__1aUJB{padding:1rem;font-size:1.063rem;font-weight:500}.style_titleIcon__1WDUq{margin-right:.5rem;display:inline-block}.style_body__3C98V{margin-top:.5rem;font-size:.875rem;line-height:1.25rem;padding-left:1rem;padding-right:1rem;padding-bottom:1rem;overflow-y:auto;overflow-x:hidden;flex-direction:column}.style_actions__3f7mN{padding:1rem;display:flex;justify-content:space-between;flex:0 0 auto;flex-wrap:wrap}.style_materialDialogBody__1XgjK{padding:0}.style_primaryActions__2EV5A>*{margin-left:.5rem}.style_secondaryActions__1ZOtb>*{margin-right:.5rem}.style_dialogWrapper__11h1h{display:flex;flex-direction:column;height:100%}", ""]);

// exports
exports.locals = {
	"layout": "style_layout__3F9l_",
	"headerContentAlignment": "style_headerContentAlignment__2DmFe",
	"title": "style_title__1aUJB",
	"titleIcon": "style_titleIcon__1WDUq",
	"body": "style_body__3C98V",
	"actions": "style_actions__3f7mN",
	"materialDialogBody": "style_materialDialogBody__1XgjK",
	"primaryActions": "style_primaryActions__2EV5A",
	"secondaryActions": "style_secondaryActions__1ZOtb",
	"dialogWrapper": "style_dialogWrapper__11h1h"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/DialogLayout/style.less
// module id = 1271
// module chunks = 8